module.exports = __webpack_public_path__ + "img/our-mission-bg-image-03.ee01889d.png";